import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/routesConstants";
import Logout from "../../../components/modal/logout";
import { makeDeleteCall } from "../../../effects/requests";
import { endPoints } from "../../../utils/endpoints";
import { cookieService } from "../../../services";
import { MyContext } from "../../../context";

interface RegisterLayoutProps {
    children: React.ReactNode;
    hideHeader?: boolean;
    showLogout?: boolean;
    contentStyle?: any
    title?: any
}

const RegisterLayout: React.FC<RegisterLayoutProps> = ({ children, hideHeader, showLogout, contentStyle, title }) => {

    const navigate = useNavigate();
    const { updateUserData } = useContext(MyContext)

    const [isLogOut, setIsLogOut] = useState(false);

    const onLogOut = () => {
        makeDeleteCall(endPoints.LOGOUT, { device_type: 'WEB' }).then(clearAll).catch(clearAll)
    }

    const clearAll = () => {
        updateUserData(null)
        cookieService.removeAllCookies();
        navigate('/sign-in');
    }

    return (
        <div className="register-layout">
            <div className="register-layout__right">
                <div className="register-layout__right-overlay" />
                <img
                    src='/assets/images/film-set.png'
                    alt="film production"
                    className="onboarding-login-image"
                />
                <div className="onboarding-login-year">
                    <img
                        src='/assets/images/yellow-6th.png'
                        alt="logo"
                    />
                </div>
            </div>
            <div className="register-layout__left">
                {!hideHeader &&
                    <header className="register-layout__header">
                        <span className="register-layout__header-title">
                            {title || 'Create a Crew Profile'}
                        </span>
                        <Link to={routes.sign_in} className="register-layout__header-link">
                            Already a member?
                            <svg
                                className="register-layout__header-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                width="20"
                                height="20"
                            >
                                <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
                            </svg>
                        </Link>
                    </header>
                }
                {showLogout &&
                    <div onClick={() => setIsLogOut(true)} className="auth-logout">
                        <img src={"/assets/images/menu-icon/Log-Out-active.svg"} alt="Logout" />
                    </div>
                }
                <div style={contentStyle} className="register-layout__content">
                    {children}
                    <Logout
                        show={isLogOut}
                        closePopup={() => setIsLogOut(false)}
                        onLogOut={() => {
                            setIsLogOut(false)
                            onLogOut?.()
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default RegisterLayout;